<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-row>
                    <v-col>
                        <v-text-field
                            label="code"
                            v-model="form.code"
                            outlined
                            hide-details="auto"
                            dense
                            disabled
                            background-color="disabled"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field
                            label="Name"
                            v-model="form.name"
                            outlined
                            hide-details="auto"
                            dense
                            :rules="[isRequired]"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-textarea
                            label="Description"
                            v-model="form.description"
                            outlined
                            dense
                            hide-details="auto"
                            >
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-col>
            <v-col>

                <v-row>
                    <v-col>
                        <v-autocomplete
                            label="Item Type"
                            dense
                            outlined
                            hide-details="auto"
                            :items="itemTypes"
                            :rules="[isRequired]"
                            item-text="name"
                            item-value="id"
                            @update:search-input="itemSearch"
                            v-model="form.type_id"
                        >

                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-autocomplete
                            label="Group"
                            dense
                            outlined
                            hide-details="auto"
                            :rules="[isRequired]"
                            :items="itemGroups"
                            item-text="display_name"
                            item-value="id"
                            @update:search-input="itemGroupSearch"
                            v-model="form.group_id"
                        >

                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-autocomplete
                            label="Measure Unit"
                            dense
                            outlined
                            hide-details="auto"
                            :rules="[isRequired]"
                            :items="measureUnits"
                            item-text="name"
                            item-value="id"
                            @update:search-input="measureUnitSearch"
                            v-model="form.measure_unit_id"
                        >
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        
    </v-form>
</template>

<script>
import { isRequired } from './../../utils/validations'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "ItemForm",
    props: {
        value: Object
    },
    data() {
        return {
            form : {
                code: "",
                name: "",
                type_id: null,
                group_id: null,
                measure_unit_id: null
            }
        }
    },
    computed: {
        ...mapGetters({
            itemTypes: "stock/itemType/list",
            itemGroups:"stock/itemGroup/search/data",
            measureUnits: "warehouse/measureUnit/search/data"
        })
    },
    methods: {
        isRequired,
        ...mapActions({
            itemSearch:"stock/itemType/get",
            itemGroupSearch: "stock/itemGroup/search/get",
            measureUnitSearch: "warehouse/measureUnit/search/get",
        }),
        validate() {
            return this.$refs.form.validate()
        }
    },
    watch: {
        form : {
            deep : true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    mounted() {
        console.log(this.value)
        this.form = {...this.form, ...this.value}
    }
}
</script>

<style>

</style>